/**
 * ConfigBadge — small pill badge showing a config value.
 *
 * Extracted from Reports components where it was identically duplicated.
 */
import { cn } from '@/lib/cn';
import { BADGE_COLORS, type BadgeColor } from '@/lib/reports.types';

interface ConfigBadgeProps {
  icon: React.ReactNode;
  text: string;
  color: BadgeColor;
}

export function ConfigBadge({ icon, text, color }: ConfigBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-2xs font-medium',
        BADGE_COLORS[color],
      )}
    >
      {icon}
      <span className="truncate max-w-[120px]">{text}</span>
    </span>
  );
}
